import { useMemo, ChangeEvent } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useFormContext, useWatch } from 'react-hook-form';
import classNames from 'classnames';
import { Check, Icon as IconType } from '@phosphor-icons/react';
import styles from '../../v2/commonComponents/SwitchSimple/SwitchSimple.module.scss';

interface SwitchFormProps {
  name: string;
  onChangeHandler?: (value: boolean) => void;
  isDisabled?: boolean;
  Icon?: IconType;
  className?: string;
}

export const SwitchForm = ({
  name,
  onChangeHandler,
  isDisabled = false,
  Icon = Check,
  className,
}: SwitchFormProps) => {
  const uniqueId = useMemo(() => uuidv4(), []);

  const { register, control } = useFormContext();
  const fieldValues = useWatch({ control });

  const value = useMemo(() => fieldValues[name], [fieldValues, name]);

  return (
    <div
      className={classNames(styles.root, className, {
        [styles.switchOn]: !!value,
        [styles.disabled]: isDisabled,
      })}
    >
      <input
        id={uniqueId}
        className={styles.input}
        type="checkbox"
        {...register(name)}
        onChange={(data: ChangeEvent<HTMLInputElement>) => {
          register(name).onChange(data);
          if (onChangeHandler) {
            onChangeHandler(data.target.checked);
          }
        }}
        disabled={isDisabled}
      />
      <label htmlFor={uniqueId} className={styles.label}>
        <span className={styles.slider}>
          <Icon weight="bold" size={14} />
        </span>
      </label>
    </div>
  );
};
